import React from 'react';
import createSvgIcon from '../../../utils/createSvgIcon';

export default createSvgIcon(
  [<g key="0"><path fill="currentColor" fillRule="evenodd" d="M19 7.0035v2.992s-1.99.0101-2 0v-2.992h-3s.01-1.9914 0-2.0014h3V2h2v3.002h3v2.0015zM13 8V5.2524A8 8 0 0 0 11 5c-4.416 0-8 3.584-8 8s3.584 8 8 8 8-3.584 8-8a8 8 0 0 0-.2524-2H16V8zM9.4 9.4l4.8 3.6-4.8 3.6z" clipRule="evenodd" /></g>,<defs key="1"></defs>,]
, 'CameraVideoAddVideoFilledx');
